export const getErrorMessageFromUrlSearchParams = url => {
  const searchParams = Array.from(url.searchParams.keys()).reduce(
    (acc, val) => ({ ...acc, [val]: url.searchParams.get(val) }),
    {}
  );

  const requriredParams = ['error', 'error_description', 'tracking'];

  const isMissingParams = requriredParams.some(param => !searchParams[param]);

  return isMissingParams ? false : searchParams;
};
